// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__5OpjW","alertIcon":"ConfirmModal_alertIcon__g1OIC"};